
import { isValidUUID } from '@/libraries/util/uuid'
import { isOwalStaff } from '@/libraries/util/permissions'
import { Service, Operation } from '@/libraries/permissions'
import {DEFAULT_PREFERENCES, DomainPreferences} from '@/libraries/permissions/domainPreferences'
import {mapGetters} from "vuex";

export default {
  isAuthenticated: state => {
    return !!state.authToken
  },
  authToken: state => {
    return state.authToken
  },
  displayName: state => {
    return state.displayName
  },
  title: state => {
    return state.title
  },
  /** Domains */
  domains: state => {
    return state.data.domains.all
  },
  domainForUUID: state => {
    return domainUUID => state.data.domains.by.uuid[domainUUID]
  },
  currentDomain: state => {
    return state.data.domains.current
  },
  currentDomainUUID: state => {
    const domain = state.data.domains.current
    if (!domain) {
      return undefined
    }
    return domain.uuid
  },
  domainForCameraUUID: state => {
    return cameraUUID => {
      return state.data.domains.by.cameraUUID[cameraUUID]
    }
  },
  /** Cameras - Single */
  cameras: state => {
    return state.data.cameras.all
  },
  cameraForUUID: state => {
    return cameraUUID => state.data.cameras.by.uuid[cameraUUID]
  },
  currentCamera: state => {
    if (!state.route.params || !state.route.params.cameraId || !isValidUUID(state.route.params.cameraId)) {
      if (!state.data.cameras || !state.data.cameras.all || !state.data.cameras.all.length) {
        return undefined
      }
      return state.data.cameras.all[0]
    }

    const cameraUUID = state.route.params.cameraId
    return state.data.cameras.by.uuid[cameraUUID]
  },
  currentCameraUUID: state => {
    if (!state.route.params || !state.route.params.cameraId || !isValidUUID(state.route.params.cameraId)) {
      if (!state.data.cameras || !state.data.cameras.all || !state.data.cameras.all.length) {
        return undefined
      }
      const currentDomainUUID = state.data.domains.current.uuid
      return state.data.cameras.by.domainUUID[currentDomainUUID][0].uuid
    }

    const cameraUUID = state.route.params.cameraId
    return cameraUUID
  },
  camerasForDomainUUID: state => {
    return (domainUUID) => {
      return state.data.cameras.by.domainUUID[domainUUID]
    }
  },
  camerasForCurrentDomain: (state, getters) => getters.camerasForDomainUUID(getters.currentDomainUUID),
  defaultCameraUUIDForDomainUUID: (state, getters) => {
    return (domainUUID) => {
      let cameras = getters.camerasForDomainUUID(domainUUID)
      if (!cameras) {
        return undefined
      }
      if (!cameras.length) {
        return undefined
      }
      return cameras[0].uuid
    }
  },
  defaultCameraUUIDForCurrentDomain: (state, getters) => { return getters.defaultCameraUUIDForDomainUUID(getters.currentDomainUUID) },

  /** User Permissions */
  isStaff: state => {
    const staff = isOwalStaff(state.email)
    return staff && !!state.authToken
  },
  preferences: (state, getters) => {
    const currentDomain = getters.currentDomain
    const defaultPreferences = DEFAULT_PREFERENCES
    if (!currentDomain) {
      return defaultPreferences
    }
    if (!currentDomain.preferences) {
      return defaultPreferences
    }
    const preferences = Object.assign({}, defaultPreferences, currentDomain.preferences)
    return preferences
  },
  hasSingleAlertSource: (state, getters) => {
    let alertSources = getters.preferences[DomainPreferences.ALERTS_SOURCE]
    return Array.isArray(alertSources) ? alertSources.length === 1 : true
  },
  /** Faces */
  frontendFaces: (state, getters) => {
    return state.faces.filter(face => {
      const faceIsEmployee = face.role === 'employee' || face.employee
      const canSeeEmployees = getters['entitlements/canPerformOperationForService'](Service.FACES, Operation.FIND_ALL)

      /** Block staff from spying on each other. */
      if (faceIsEmployee && !canSeeEmployees) {
        return false
      }

      /** Don't show visitors */
      const personName = face.person_name.toLowerCase()
      if (personName.includes('visitor')) return false
      return true
    })
  },
  faceForUUID: state => {
    return faceId => {
      return state.faces.find(face => face.frontend_face_uuid === faceId)
    }
  },
  nameForUUID: state => {
    return faceId => {
      return state.faces.find(face => face.frontend_face_uuid === faceId).person_name
    }
  },
}
